<template>
    <v-app>
        <Toolbar title="Device Shipments"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/shipping'})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">Shipping Order</div>
                                <span class="grey--text">ID: {{ orderId }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-flex xs12 md10 offset-md1>
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>1. Device Retrieval</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card>
                    <v-card-title>
                        <v-card-text class="headline">
                            <DeviceType v-bind:device-type="deviceModel"/>
                        </v-card-text>
                        <v-text-field
                                v-model="serial"
                                label="Enter new device serial number"
                                single-line
                                hide-details
                                mask="###############"
                                required
                        ></v-text-field>
                        <v-btn color="default" @click="orderSave">Save Serial Number</v-btn>
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1>
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>2. Device Loading</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card>
                    <v-card-title>
                        <v-card-text class="headline">
                            Load via USB stick using build
                            <DeviceBuild v-bind:device-type="deviceModel"/>
                            <br/>
                            Acquirer: {{ getAcquirer(getOrder.deviceType) }}<br/>
                            Group: {{ groupName }}<br/>
                            MID: {{ getOrder.merchantId }} TID: {{ getOrder.terminalId }}
                        </v-card-text>
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1>
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>3. Shipping Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card>
                    <v-card-title>
                        <v-card-text class="headline">
                            <div class="font-weight-bold">Contact Details</div>
                            <div v-if="getOrder.contactName">{{getOrder.contactName}}</div>
                            <div v-if="getOrder.contactEmail">{{getOrder.contactEmail}}</div>
                            <div v-if="getOrder.contactPhone">{{getOrder.contactPhone}}</div>
                            <br/>
                            <div class="font-weight-bold">Shipping Address</div>
                            <div v-if="getOrder.business">{{getOrder.business}}</div>
                            <div v-if="getOrder.shippingLine1">{{getOrder.shippingLine1}}</div>
                            <div v-if="getOrder.shippingLine2">{{getOrder.shippingLine2}}</div>
                            <div v-if="getOrder.shippingCity">{{getOrder.shippingCity}}</div>
                            <div v-if="getOrder.shippingState">{{getOrder.shippingState}}</div>
                            <div v-if="getOrder.shippingPostCode">{{getOrder.shippingPostCode}}</div>
                            <div v-if="getOrder.shippingCountry">{{countries[getOrder.shippingCountry]}}</div>
                        </v-card-text>
                        <v-text-field
                                v-model="shippingReference"
                                label="Enter shipping or courier reference"
                                single-line
                                hide-details
                                required
                        ></v-text-field>
                        <v-btn color="default" @click="orderSave">Save Shipping Reference</v-btn>
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1>
                <v-layout>
                    <v-flex xs3></v-flex>
                    <v-flex xs3><v-btn color="warning" @click="rejectDialog = true">Reject Order</v-btn></v-flex>
                    <v-flex xs3><v-btn color="info" @click="orderSave">Save Order</v-btn></v-flex>
                    <v-flex xs3><v-btn color="success" :disabled="!completeEnabled" @click="completeDialog = true">
                        Mark as Complete
                    </v-btn></v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="completeDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Complete this Order?</v-card-title>
                    <v-card-text>Please confirm that you want to mark this order as complete. Only do this once
                        the device is prepared and ready for shipment to the merchant.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click.native="orderComplete">Yes, complete</v-btn>
                        <v-btn color="green darken-1" flat @click.native="completeDialog = false">No, cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="rejectDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Reject this Order?</v-card-title>
                    <v-card-text>Please confirm that you want to reject this order. This returns the order to
                        the requester for further action.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click.native="orderReject">Yes, reject</v-btn>
                        <v-btn color="green darken-1" flat @click.native="rejectDialog = false">No, cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-content>
    </v-app>
</template>

<script>
    import {cv3ukapp, cmp200ukapp, cv3ppukapp, cmp200gbapp, cv3amtukapp} from '../castles/castles_uk_aibms_pp'
    import {cv3ukdemo, cmp200ukdemo, cv3ppukdemo} from '../castles/castles_uk_demo'
    import {cv3roiapp, cmp200roiapp, cv3pproiapp, cv3amtroiapp} from '../castles/castles_roi_aibms_pp'
    import {cv3roidemo, cmp200roidemo, cv3pproidemo} from '../castles/castles_roi_demo'
    import {cv3ukbpp, cv3ppukbpp} from '../castles/castles_uk_barclays_pp'
    import Moment from 'moment'
    import Toolbar from '../components/Toolbar'
    import DeviceType from '../components/DeviceType'
    import DeviceBuild from '../components/DeviceBuild'
    import {mapGetters, mapActions} from 'vuex'
    import goSHA256 from '../sha256'

    const fb = require('../firebase')

    export default {
        name: "Shipment",
        components: {Toolbar, DeviceType, DeviceBuild},
        data() {
            return {
                countries: {'uk': 'United Kingdom', 'roi': 'Republic of Ireland', 'ni': 'Northern Ireland'},
                serial: '',
                shippingReference: '',
                rejectDialog: false,
                completeDialog: false,
                defaultSettings: {
                    'aibms_uk_mp200_pp': cmp200ukapp,
                    'aibms_uk_v3_mid_countertop_ethernet_wifi_pp': cv3ukapp,
                    'aibms_uk_v3_mid_pinpad_ethernet_pp': cv3ppukapp,
                    'aibms_uk_v3_portable_wifi_pp': cv3ukapp,

                    'aibms_uk_v3_mid_countertop_ethernet_wifi_amt': cv3amtukapp,

                    'aibms_roi_mp200_pp': cmp200roiapp,
                    'aibms_roi_v3_mid_countertop_ethernet_wifi_pp': cv3roiapp,
                    'aibms_roi_v3_mid_pinpad_ethernet_pp': cv3pproiapp,
                    'aibms_roi_v3_portable_wifi_pp': cv3roiapp,

                    'aibms_roi_v3_mid_countertop_ethernet_wifi_amt': cv3amtroiapp,

                    'barclays_uk_v3_mid_countertop_ethernet_wifi_pp': cv3ukbpp,
                    'barclays_uk_v3_mid_pinpad_ethernet_pp': cv3ppukbpp,
                    'barclays_uk_v3_portable_wifi_pp': cv3ukbpp,

                    'demo_uk_mp200_wifi': cmp200ukdemo,
                    'demo_uk_v3_mid_countertop_ethernet_wifi': cv3ukdemo,
                    'demo_uk_v3_mid_pinpad_ethernet': cv3ppukdemo,
                    'demo_uk_v3_portable_wifi': cv3ukdemo,

                    'demo_roi_mp200': cmp200roidemo,
                    'demo_roi_v3_mid_countertop_ethernet_wifi': cv3roidemo,
                    'demo_roi_v3_mid_pinpad_ethernet': cv3pproidemo,
                    'demo_roi_v3_portable_wifi': cv3roidemo,

                    'aibms_uk_mp200_gb': cmp200gbapp
                }
            }
        },
        computed: {
            ...mapGetters(['getOrder']),
            orderId: function () {
                return this.$route.params.order_id
            },
            dateFrom: function () {
                return Moment(this.getOrder.updatedAt).fromNow()
            },
            deviceModel: function () {
                return this.getOrder.deviceType
            },
            completeEnabled: {
                get() {
                    return (this.present(this.shippingReference) && this.present(this.serial))
                }
            },
            groupName: function () {
                if (this.getOrder === undefined) { return '' }
                if (this.getOrder.group === undefined) { return '' }
                if (this.$store.state.groups === undefined) { return '' }
                if (this.$store.state.groups[this.getOrder.group] === undefined) { return '' }
                return this.$store.state.groups[this.getOrder.group].name.toString()
            },
            getSerial: function () {
                if (this.getOrder === undefined) { return '' }
                if (this.getOrder.serial === undefined) { return '' }
                return this.getOrder.serial
            },
            getShippingReference: function () {
                if (this.getOrder === undefined) { return '' }
                if (this.getOrder.shippingReference === undefined) { return '' }
                return this.getOrder.shippingReference
            }
        },
        watch: {
            serial: function () {
                this.$store.commit('updateOrder', ['serial', this.serial])
            },
            shippingReference: function () {
                this.$store.commit('updateOrder', ['shippingReference', this.shippingReference])
            },
            getOrder: function () {
                this.serial = this.getOrder.serial
                this.shippingReference = this.getOrder.shippingReference
            }
        },
        mounted() {
            this.fetchAll()
            this.fetchOrder(this.orderId)
        },
        methods: {
            ...mapActions(['fetchOrder', 'saveOrderForm', 'fetchAll', 'getGroupName']),
            pad: function (num, size) {
                let s = num + ''
                while (s.length < size) s = '0' + s
                return s
            },
            present: function (val) {
                let output = true
                if (val === undefined) {
                    output = false
                }
                if (val === '') {
                    output = false
                }
                if (val === 'undefined') {
                    output = false
                }
                if (val === null) {
                    output = false
                }
                return output
            },
            getAcquirer: function (deviceType) {
                let acquirer = 'AIBMS'

                if (deviceType !== undefined) {

                    if (deviceType.indexOf('demo_') !== -1) {
                        acquirer = 'Demo'
                    }

                    if (deviceType.indexOf('barclays_') !== -1) {
                        acquirer = 'Barclaycard'
                    }
                }

                return acquirer
            },
            orderReject: function () {
                this.rejectDialog = false
                this.$store.commit('updateOrder', ['status', 'draft'])
                this.saveOrderForm()

                this.$router.push('/shipping')
            },
            orderSave: function () {
                if (this.serial !== '') {
                    this.serial = this.pad(this.serial, 15)
                }
                this.$store.commit('updateOrder', ['serial', this.serial])
                this.$store.commit('updateOrder', ['shippingReference', this.shippingReference])
                this.generateSettings()
                this.saveOrderForm()
            },
            generateSettings: function () {
                if (this.present(this.getOrder.serial)) {
                    let newSettings = this.defaultSettings[this.getOrder.deviceType]
                    if (newSettings === undefined) {
                        newSettings = {}
                    }
                    newSettings['device.name'] = this.getOrder.deviceName
                    newSettings['device.show_name'] = this.getOrder.showDeviceName
                    newSettings['merchant.master_key'] = this.getOrder.macKey
                    newSettings['header.line1'] = this.getOrder.receiptHeader1
                    newSettings['header.line2'] = this.getOrder.receiptHeader2
                    newSettings['header.line3'] = this.getOrder.receiptHeader3
                    newSettings['header.line4'] = this.getOrder.receiptHeader4
                    newSettings['header.line5'] = this.getOrder.receiptHeader5
                    newSettings['footer.line1'] = this.getOrder.receiptFooter1
                    newSettings['footer.line2'] = this.getOrder.receiptFooter2
                    newSettings['footer.line3'] = this.getOrder.receiptFooter3
                    newSettings['footer.line4'] = this.getOrder.receiptFooter4
                    newSettings['footer.line5'] = this.getOrder.receiptFooter5
                    newSettings['merchant.cashback'] = this.getOrder.cashBackEnabled
                    newSettings['merchant.cashback_limit'] = Number(this.getOrder.cashBackLimitAmount * 100)
                    newSettings['merchant.industry'] = this.getOrder.industry
                    newSettings['merchant.manual_limit'] = Number(this.getOrder.manualLimitAmount * 100)

                    newSettings['merchant.prompt_reference'] = this.getOrder.promptReferenceEnabled
                    newSettings['merchant.swipe_limit'] = Number(this.getOrder.swipeLimitAmount * 100)
                    newSettings['merchant.terminalid'] = this.getOrder.terminalId
                    newSettings['merchant.tip_enabled'] = this.getOrder.tipEnabled
                    if (this.getOrder.motoEnabled === undefined) {
                        this.getOrder.motoEnabled = false
                    }
                    if (this.getOrder.deviceType.indexOf('barclays_') !== -1) {
                        this.getOrder.merchantId = this.pad(this.getOrder.merchantId, 7)
                    } else {
                        this.getOrder.merchantId = this.pad(this.getOrder.merchantId, 9)
                    }
                    newSettings['merchant.merchantid'] = this.getOrder.merchantId

                    newSettings['merchant.moto_enabled'] = this.getOrder.motoEnabled
                    if (this.getOrder.apiOnly === undefined) {
                        this.getOrder.apiOnly = false
                    }
                    newSettings['merchant.api_only'] = this.getOrder.apiOnly
                    if ((this.getOrder.apiUsername !== '') && (this.getOrder.apiUsername !== undefined)) {
                        newSettings['auth.user'] = this.getOrder.apiUsername
                    }
                    if ((this.getOrder.apiPassword !== '') && (this.getOrder.apiPassword !== undefined)) {
                        newSettings['auth.clear_password'] = this.getOrder.apiPassword
                        newSettings['auth.password'] = goSHA256(this.getOrder.apiPassword)
                    }

                    for (let i = 1; i < 6; i++) {
                        if (newSettings['footer.line' + i.toString()] === undefined) {
                            newSettings['footer.line' + i.toString()] = ''
                        }
                        if (newSettings['header.line' + i.toString()] === undefined) {
                            newSettings['header.line' + i.toString()] = ''
                        }
                    }

                    let filteredSettings = {}

                    for (let field in newSettings) {
                        if (newSettings.hasOwnProperty(field)) {
                            if (newSettings[field] !== undefined) {
                                filteredSettings[field] = newSettings[field]
                            }
                        }
                    }

                    fb.settingsCollection.doc('castles_' + this.pad(this.getOrder.serial, 15) + '@kineticsmart.com').set(filteredSettings)
                        .then(() => {
                            this.$store.commit('hideProgress')
                            this.$store.commit('showSnack', 'Settings generated.')
                        })
                }
            },
            orderComplete: async function () {
                this.$store.commit('updateOrder', ['status', 'complete'])
                this.completeDialog = false
                this.generateSettings()
                this.saveOrderForm()

                // add new serial to group
                await fb.groupsCollection
                    .doc(this.getOrder.group)
                    .get()
                    .then((doc) => {
                        let newArray = doc.data().devices
                        if (newArray.indexOf(this.getOrder.serial) === -1) {
                            newArray.push(this.pad(this.getOrder.serial, 15))
                            fb.groupsCollection
                                .doc(this.getOrder.group)
                                .set({devices: newArray}, {merge: true})
                        }
                    })

                this.$router.push('/shipping')
            }
        }
    }
</script>

<style scoped>

</style>
